export default __webpack_public_path__ + "static/media/Brantano.65cfb680.png";